export default "__VITE_ASSET__0ba3ded8__"